//合作状态
export var cooperationStatusEnum = [{
  label: '待联系',
  value: 1
}, {
  label: '初次联系无回复',
  value: 2
}, {
  label: '资料收集',
  value: 3
}, {
  label: '商务洽谈',
  value: 4
}, {
  label: '签订合同',
  value: 5
}, {
  label: '合同终止',
  value: 6
}];
export var ticketTypeEnum = [{
  label: '无票',
  value: 1
}, {
  label: '普票',
  value: 2
}, {
  label: '专票',
  value: 3
}, {
  label: '混合票种',
  value: 4
}];
export var settlementMethodEnum = [{
  label: '提供账期',
  value: 1
}, {
  label: '现货现款',
  value: 2
}, {
  label: '部分预付',
  value: 3
}, {
  label: '预存代发',
  value: 4
}];
//操作类型
export var operationTypeEnum = [{
  label: '充值',
  value: 1
}, {
  label: '扣费',
  value: 2
}];
//价格形式
export var priceEnum = [{
  label: '价格',
  value: 1
}, {
  label: '折扣',
  value: 2
}];
//商户
export var merchantEnum = [{
  label: '自营',
  value: 1
}, {
  label: '锦诚',
  value: 2
}];
//平台状态
export var platformStatusEnum = [{
  label: '上架',
  value: 1
}, {
  label: '下架',
  value: 0
}];
//商家状态
export var supperStatusEnum = [{
  label: '上架',
  value: 1
}, {
  label: '下架',
  value: 0
}];

//运营方式
export var platformTypeEnum = [{
  label: '自营',
  value: 1
}, {
  label: '代运营',
  value: 2
}];